import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

export const THEMES = ["atelier", "grid", "noir", "indigo"];
export const DEFAULT_THEME = "grid";
const STORAGE_KEY = "pf-theme";

function readInitialTheme() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (THEMES.includes(saved)) return saved;
  } catch (e) {}
  // Fall back to whatever the early inline script already set on <html>.
  const current = document.documentElement.getAttribute("data-theme");
  return THEMES.includes(current) ? current : DEFAULT_THEME;
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(readInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {}
  }, [theme]);

  const setTheme = (next) => {
    if (THEMES.includes(next)) setThemeState(next);
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, themes: THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
